module.exports = __webpack_public_path__ + "static/img/qyzu.449156c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/company/qyzu.png
// module id = 4G9Y
// module chunks = 3